export default __webpack_public_path__ + "static/media/smsAuthenticator.4ea2efed.svg";